import { RouterProvider, type DataRouter } from "react-router-dom";

import { AppProviders } from "./providers";
import { router as browserRouter } from "./router";

interface AppProps {
  router?: DataRouter;
}

export function App({ router = browserRouter }: AppProps) {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
